<script setup>
import { deviceStore } from './../stores/deviceStore'
// import LandingPage from './LandingPage/HomeView.vue'
import MediaPlayer from './mediaPlayer/MediaPlayer.vue'
const store = deviceStore();

defineProps({
  viewportID: {
    type: String,
    required: true
  },
  DisplayState:  {
    type: String,
    required: true
  },
  isLanding:  {
    type: String,
    required: true
  },
  mediaObj: {
    type: Object,
    default: {

    }
  }
})
</script>

<script>
export default {
components: {
      MediaPlayer
 },
  data: () => ({
  }),
  methods: {

  }
}
</script>

<template v-for="termination in store.terminationPoints">
      <div  v-if="viewportID==termination.viewportID" name="viewportID" :id="termination.terminationID"   style="width:100%;height:100%;">
            <MediaPlayer v-if="DisplayState == Media" :stream="{streamID:termination.terminationID,type:'video',MediaSource:'https://oxygencommunications.s3.amazonaws.com/recordings/ringtones/simpliademo.mp4',PlayerProp:{autoplay:true,muted:true,playsinline:true}}"  :viewportID="viewportID" :DisplayState="DisplayState"></MediaPlayer>
      </div>
</template>
